import { RetroOrProspectivePcfType } from './IFootprint';

export enum DeclaredUnit {
  piece = 'piece',
  liter = 'liter',
  kilogram = 'kilogram',
  cubicMeter = 'cubic_meter',
  kilowattHour = 'kilowatt_hour',
  megajoule = 'megajoule',
  tonKilometer = 'ton_kilometer',
  squareMeter = 'square_meter',
  hour = 'hour',
  megabit = 'megabit',
  second = 'second',
  megabitSecond = 'megabit second',
}

// `second` and `megabit` are intentionally excluded from dropdowns, but remain
// in the DeclaredUnit enum so existing footprints using them still display correctly.
export const NON_SELECTABLE_DECLARED_UNITS: DeclaredUnit[] = [
  DeclaredUnit.second,
  DeclaredUnit.megabit,
];

export const SELECTABLE_DECLARED_UNITS: DeclaredUnit[] = (
  Object.values(DeclaredUnit) as DeclaredUnit[]
).filter((unit) => {
  return !NON_SELECTABLE_DECLARED_UNITS.includes(unit);
});

export enum CalculationDeclaredUnit {
  kilogram = DeclaredUnit.kilogram,
  piece = DeclaredUnit.piece,
  liter = DeclaredUnit.liter,
  squareMeter = DeclaredUnit.squareMeter,
}

export const DeclaredUnitToPlainSymbolsMap = {
  [DeclaredUnit.piece]: 'piece',
  [DeclaredUnit.liter]: 'L',
  [DeclaredUnit.kilogram]: 'kg',
  [DeclaredUnit.cubicMeter]: 'm³',
  [DeclaredUnit.kilowattHour]: 'kWh',
  [DeclaredUnit.megajoule]: 'MJ',
  [DeclaredUnit.tonKilometer]: 'tkm',
  [DeclaredUnit.squareMeter]: 'm²',
  [DeclaredUnit.hour]: 'h',
  [DeclaredUnit.megabit]: 'Mb',
  [DeclaredUnit.second]: 's',
  [DeclaredUnit.megabitSecond]: 'Mbs',
};

interface ComponentDetailsPcf {
  pcfIncludingBiogenic: number;
  pcfExcludingBiogenic: number;
  id: string;
  declaredUnit: DeclaredUnit;
  unitaryProductAmount: number;
  latestPublishedVersion: number;
  geographyRegionOrSubregion: string;
  validityPeriodEnd: string;
  geographyCountry: string;
  retroOrProspectivePcfType: RetroOrProspectivePcfType;
}

export interface IComponentDetails {
  id: number;
  productIds: string[];
  productDescription: string;
  productName: string;
  companyName: string;
  companyIds: string[];
  pcfLegalStatement?: string;
  created: string; // ISO date string
  pcf: ComponentDetailsPcf;
  ownProductId?: string;
  ownProductName?: string;
  otherRequestData?: {
    component_name: string;
    component_id: string;
  };
  restricted?: boolean;
  /** Set when the provider company's data usage terms have to be accepted first. */
  termsAcceptanceRequired?: boolean;
  providerCompanyName?: string;
}
